// Generated file : do not modify
import { GraphAnswer } from '@/extend/classes/GraphData';
import { GraphMinimum } from '@/extend/classes/GraphData';
import {getRequestConfig} from "@/framework/base/helpers/HttpHelper.ts";

// Plage Creneau
export default class PlageCreneau  {
  // Id créneau
  public id: number;
  // Id creneau
  public creneauId: number;
  // Id contrat
  public contratId: number;
  // Début
  public heureDebut: string | null;
  // Fin
  public heureFin: string | null;
  // Type d'activité
  public activiteId: number;
  // Id lieu
  public lieuId: number;
  // activité valide
  public valid: boolean;
  // Couleur de l'activite pour la frise
  public color: string;
  // Graph answers
  public graphAnswers: GraphAnswer[];
  // Graph minimum
  public graphMinimum: GraphMinimum;
  // Commande non exécutée
  public failed: boolean;

  constructor() {
    this.id = 0;
    this.creneauId = 0;
    this.contratId = 0;
    this.heureDebut = null;
    this.heureFin = null;
    this.activiteId = 0;
    this.lieuId = 0;
    this.valid = false;
    this.color = '';
    this.graphAnswers = [];
    this.graphMinimum = new GraphMinimum();
    this.failed = false;
  }

  public static fromJson (obj: PlageCreneau): PlageCreneau {
    const newPlageCreneau: PlageCreneau = new PlageCreneau();
    newPlageCreneau.id = obj.id;
    newPlageCreneau.creneauId = obj.creneauId;
    newPlageCreneau.contratId = obj.contratId;
    newPlageCreneau.heureDebut = obj.heureDebut;
    newPlageCreneau.heureFin = obj.heureFin;
    newPlageCreneau.activiteId = obj.activiteId;
    newPlageCreneau.lieuId = obj.lieuId;
    newPlageCreneau.valid = obj.valid;
    newPlageCreneau.color = obj.color;
    newPlageCreneau.graphAnswers = JSON.parse(JSON.stringify(obj.graphAnswers));
    newPlageCreneau.graphMinimum = JSON.parse(JSON.stringify(obj.graphMinimum));
    newPlageCreneau.failed = obj.failed;
    return newPlageCreneau;
  }

  public toJsonPlageCreneau (): string {
    const json = {
      id: this.id,
      creneauId: this.creneauId,
      contratId: this.contratId,
      heureDebut: this.heureDebut,
      heureFin: this.heureFin,
      activiteId: this.activiteId,
      lieuId: this.lieuId,
      valid: this.valid,
      color: this.color,
      graphAnswers: this.graphAnswers,
      graphMinimum: this.graphMinimum,
    }
    return JSON.stringify(json);
  }

  public fromPlageCreneau (obj: PlageCreneau): void {
    this.id = obj.id;
    this.creneauId = obj.creneauId;
    this.contratId = obj.contratId;
    this.heureDebut = obj.heureDebut;
    this.heureFin = obj.heureFin;
    this.activiteId = obj.activiteId;
    this.lieuId = obj.lieuId;
    this.valid = obj.valid;
    this.color = obj.color;
    this.graphAnswers = obj.graphAnswers;
    this.graphMinimum = obj.graphMinimum;
    this.failed = obj.failed;
  }

  public comparePlageCreneau (value: PlageCreneau): boolean {
    return (this.toJsonPlageCreneau() == value.toJsonPlageCreneau());
  }

  public clonePlageCreneau (): PlageCreneau {
    return PlageCreneau.fromJson(this);
  }

  // eslint-disable-next-line
  public static getDate(plageCreneaus: PlageCreneau[]) {
  }
}
